import axios from 'axios';

const TOKEN_KEY = 'diese_jwt';

export function getToken()          { return localStorage.getItem(TOKEN_KEY); }
export function saveToken(token)    { localStorage.setItem(TOKEN_KEY, token); }
export function removeToken()       { localStorage.removeItem(TOKEN_KEY); }

function authHeaders() {
  const token = getToken();
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
}

// ─── Auth ───────────────────────────────────────────────────────

export const login = async (email, token) => {
  const response = await axios.post('/api/auth/login', { email, token });
  return response.data;
};

export const fetchMe = async () => {
  const response = await axios.get('/api/auth/me', { headers: authHeaders() });
  return response.data;
};

// ─── Monitoring ─────────────────────────────────────────────────

export const fetchMonitoringStatusServeurDieseData = async () => {
  const response = await axios.post(
    '/api/monitoring/status/serveur-diese',
    {},
    { headers: authHeaders() }
  );
  return response.data;
};

export const fetchMonitoringStatusDetailsServeurDieseData = async (serverId) => {
  const response = await axios.post(
    '/api/etat-serveur/details-information',
    { serverId },
    { headers: authHeaders() }
  );
  return response.data;
};

export const fetchMonitoringServicesData = async () => {
  const response = await axios.post(
    '/api/monitoring/status/service-diese',
    {},
    { headers: authHeaders() }
  );
  return response.data;
};

export const fetchServerMetricsHistory = async (serveurId, hours = 24) => {
  const response = await axios.post(
    '/api/monitoring/serveur-diese/metrics-history',
    { serveurId, hours },
    { headers: authHeaders() }
  );
  return response.data;
};

export const fetchSingleMetricHistory = async (serveurId, metricName, hours = 24) => {
  const response = await axios.post(
    '/api/monitoring/serveur-diese/metric-history',
    { serveurId, metricName, hours },
    { headers: authHeaders() }
  );
  return response.data;
};

export const fetchWebsiteLatencyHistory = async (clientId, hours = 24) => {
  const response = await axios.post(
    '/api/monitoring/website/latency-history',
    { clientId, hours },
    { headers: authHeaders() }
  );
  return response.data;
};

export const createClient = async ({ idClient, subClient, hasApi }) => {
  const response = await axios.post(
    '/api/clients/create',
    { idClient, subClient, hasApi },
    { headers: authHeaders() }
  );
  return response.data;
};

export const fetchMonitoringWebsiteData = async (page = 1, limit = 20) => {
  const response = await axios.post(
    '/api/monitoring/status/website-diese',
    { page, limit },
    { headers: authHeaders() }
  );
  return response.data;
};
